import React from 'react';

export const Pdf = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="letters"
      d="M6.32217 13.052V15H5.02425V9.172H6.99801C7.39225 9.172 7.73017 9.22133 8.01177 9.32C8.29593 9.416 8.52889 9.54933 8.71065 9.72C8.89497 9.89066 9.03065 10.092 9.11769 10.324C9.20473 10.556 9.24825 10.8067 9.24825 11.076C9.24825 11.3667 9.20345 11.6333 9.11385 11.876C9.02425 12.1187 8.88729 12.3267 8.70297 12.5C8.51865 12.6733 8.28441 12.8093 8.00025 12.908C7.71865 13.004 7.38457 13.052 6.99801 13.052H6.32217ZM6.32217 12.032H6.99801C7.33593 12.032 7.57913 11.948 7.72761 11.78C7.87609 11.612 7.95033 11.3773 7.95033 11.076C7.95033 10.9427 7.93113 10.8213 7.89273 10.712C7.85433 10.6027 7.79545 10.5093 7.71609 10.432C7.63929 10.352 7.54073 10.2907 7.42041 10.248C7.30265 10.2053 7.16185 10.184 6.99801 10.184H6.32217V12.032Z"
      fill="black"
    />
    <path
      className="letters"
      d="M14.9982 12.084C14.9982 12.5053 14.9278 12.8947 14.787 13.252C14.6488 13.6067 14.453 13.9147 14.1995 14.176C13.9461 14.4347 13.6401 14.6373 13.2817 14.784C12.9259 14.928 12.5304 15 12.0952 15H9.92175V9.172H12.0952C12.5304 9.172 12.9259 9.24533 13.2817 9.392C13.6401 9.53866 13.9461 9.74133 14.1995 10C14.453 10.2587 14.6488 10.5667 14.787 10.924C14.9278 11.2787 14.9982 11.6653 14.9982 12.084ZM13.6696 12.084C13.6696 11.796 13.6337 11.536 13.5621 11.304C13.4904 11.072 13.3867 10.876 13.251 10.716C13.1179 10.5533 12.9541 10.4293 12.7595 10.344C12.5649 10.256 12.3435 10.212 12.0952 10.212H11.2273V13.96H12.0952C12.3435 13.96 12.5649 13.9173 12.7595 13.832C12.9541 13.744 13.1179 13.62 13.251 13.46C13.3867 13.2973 13.4904 13.1 13.5621 12.868C13.6337 12.636 13.6696 12.3747 13.6696 12.084Z"
      fill="black"
    />
    <path
      className="letters"
      d="M19.2237 9.172V10.212H16.9274V11.688H18.8397V12.732H16.9274V15H15.6218V9.172H19.2237Z"
      fill="black"
    />
    <path
      d="M1 7C1 4.79086 2.79086 3 5 3H19C21.2091 3 23 4.79086 23 7V17C23 19.2091 21.2091 21 19 21H5C2.79086 21 1 19.2091 1 17V7Z"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
